
import {Component, Input, Output, EventEmitter, OnInit} from '@angular/core';
import {UserResponse} from "../../classes/user-response";


@Component({
  selector: 'radio-type',
  templateUrl: './radio-type.component.html',
  styleUrls: ['./radio-type.component.css']
})
export class RadioTypeComponent implements OnInit{

  //self explanatory

  @Input() question_index : number;
  @Input() question_name : string;
  @Input() question_name_second : string;
  @Input() question_options : [string];
  @Input() question_options_second : string;
  @Input() is_mandt : boolean;

  @Input() question_number : number;
  @Input() is_Qn_Dep : boolean;
  @Output() user_Resp = new EventEmitter<string[]>();
  @Input() indexOfRepeater : number;
  @Input() userRes : string[];
  @Input() userResInitial : number[];

  options : Option[];

  constructor(){

  }

  ngOnInit(){

    this.options = [];

    for(let i=0;i<this.question_options.length ; i++){
      let opt : Option = new Option();
      opt.checked = false;
      opt.src = "../../../assets/images/radio_button_unchecked.svg";
      this.options.push(opt);
    }

    if(this.userRes[this.indexOfRepeater] != undefined && this.userRes[this.indexOfRepeater].length > 0){

      let opt = parseInt(this.userRes[this.indexOfRepeater]);

      if(!isNaN(opt) && opt > -1){
        this.options[opt].checked = true;
        this.options[opt].src = "../../../assets/images/radio_button_checked.svg";
      }

    }

  }

  changed(i : number){


    for(let j=0;j<this.options.length;j++){
      this.options[j].checked = false;
      this.options[j].src = "../../../assets/images/radio_button_unchecked.svg";
    }

    this.options[i].checked = true;
    this.options[i].src = "../../../assets/images/radio_button_checked.svg";

    this.user_Resp.emit([this.indexOfRepeater.toString(),this.question_number.toString(),i.toString()]);



  }

  getUniqueId(i : string): string{
    if(this.indexOfRepeater){
      return this.question_index.toString() + i + this.indexOfRepeater + this.question_number;
    }
    return this.question_index.toString() + i + this.question_number;
  }

}

class Option{
  src : string;
  checked : boolean;
}



// WEBPACK FOOTER //
// ./src/app/questions-type/radio-type/radio-type.component.ts